function getValueByKeyObject(a, b) {
  const results = [];

  b.forEach((chave) => {
    //b is array simple
    a.forEach((obj) => {
      // a is array of object
      if (Object.prototype.hasOwnProperty.call(obj, chave)) {
        results.push({ [chave]: obj[chave] });
      }
    });
  });

  return results;
}

function checkIfExistsKeyOnObject(a, b) {
  return a?.some((chave) =>
    b?.some((obj) => Object.prototype.hasOwnProperty.call(obj, chave))
  );
}

function replaceFlagByInputValue(paramsInString, obj) {
  const parsed = JSON.parse(paramsInString);
  const regex = /<#(.*?)#>/g;

  const mapSubstituicoes = new Map();

  obj.forEach((obj) => {
    Object.entries(obj).forEach(([chave, valor]) => {
      mapSubstituicoes.set(chave.toUpperCase(), valor.value);
    });
  });

  for (const key in parsed) {
    if(String(parsed[key])?.includes('<#') && String(parsed[key])?.includes('#>')){
      parsed[key] = parsed[key]?.replace(regex, (_, flag) => {
        const valorSubstituto = mapSubstituicoes.get(flag.toUpperCase());
        return valorSubstituto !== undefined ? valorSubstituto : `<#${flag}#>`;
      });
    }
  }
  
  return parsed;
}

const fnReplaceParamKeyWithFilteredValue = (arr, s) => {
  const obj = arr[0];
  let values = []

  return s.replace(/<#[^#]+#>/g, (match) => {
    const key = match.slice(2, -2);

    if(Array.isArray(obj[key])){
      obj[key][0]?.values?.map(item => {
        values.push(item.value)
      })
      return values.length == 1 ? (!!values[0] ? values[0] : null) : values.join(",")
    }

    return (!!obj[key]?.value && obj[key].value) || match;
  });
};

/**
 * 
 * @param {*} filterParams 
 * @description Array a ser filtrado
 * @param {*} key 
 * @description Chave de comparação
 * @param {*} hasExists 
 * @description Quando true, retorna se o objeto existe (retorno booleano)
 * @param {*} defaultValue 
 * @description Campo de referencia a ser retornado o valor (definido com valor padrão)
 * @returns 
 */
const fnGetValueByKey = (filterParams, key, hasExists = false, defaultValue = "Valor_Componente") => {
  if(hasExists) return filterParams?.filter((obj) => obj.Chave_Transacao_Componente == key).length > 0;
  return filterParams?.find((obj) => obj.Chave_Transacao_Componente == key)?.[defaultValue] || null;
};

/**
 * Busca o IP público do cliente
 * @returns {Promise<string>} o IP ou "0.0.0.0" em caso de falha
 */
async function getClientIp() {
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    if (!res.ok) throw new Error("Falha ao obter IP");
    const { ip } = await res.json();
    return ip;
  } catch (err) {
    console.error("Erro ao buscar IP:", err);
    return "0.0.0.0";
  }
}

/**
 * @description Função recursiva para agrupar items pela chave pai
 * @param {*} data 
 * @description Array a ser filtrado
 * @param {*} paiId 
 * @returns 
 */
function fnGroupRecursiveData(data, paiId = "0_001") {
    return data
      .filter((item) => item.ID_Transacao_Componente_Pai == paiId)
      .map((item) => {
        const Childrens = fnGroupRecursiveData(
          data,
          item.ID_Transacao_Componente
        );
        return { ...item, Childrens: [...Childrens] };
      })
      .map((i) => {
        if (paiId == "0_001") return { [i["Chave_Transacao_Componente"]]: i };
        return i;
      });
  }

export {
  fnGroupRecursiveData,
  fnGetValueByKey,
  fnReplaceParamKeyWithFilteredValue,
  getValueByKeyObject,
  checkIfExistsKeyOnObject,
  replaceFlagByInputValue,
  getClientIp,

};

/**
 * Calcula uma data futura adicionando meses ao horário atual,
 * tratando estouros de fim de mês e retornando o formato padrão ISO (AAAA-MM-DD)
 * exigido por componentes de input de data.
 * @param {number} [monthsAhead=0] - Quantidade de meses a adicionar.
 * @returns {string} Data no formato "YYYY-MM-DD".
 */
export const maxDate = (monthsAhead = 0) => {
  const months = Number.isInteger(monthsAhead) ? monthsAhead : 0;
  
  const baseDate = new Date();
  const targetDate = new Date(baseDate.getTime());
  
  targetDate.setMonth(baseDate.getMonth() + months);

  const expectedMonth = (((baseDate.getMonth() + months) % 12) + 12) % 12;

  if (targetDate.getMonth() !== expectedMonth) {
    targetDate.setDate(0);
  }

  const offset = targetDate.getTimezoneOffset();
  const localDate = new Date(targetDate.getTime() - (offset * 60 * 1000));
  
  return localDate.toISOString().slice(0, 10);
};